"use client";

import { KeyboardEvent, useRef } from "react";
import { ArrowUp, Loader2 } from "lucide-react";
import Link from "next/link";

interface TozyInputProps {
  value: string;
  onChange: (val: string) => void;
  onSend: () => void;
  isSending: boolean;
  isAuthenticated: boolean;
}

const TozyInput = ({ value, onChange, onSend, isSending, isAuthenticated }: TozyInputProps) => {
  const ref = useRef<HTMLTextAreaElement>(null);

  const handleKeyDown = (e: KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      onSend();
    }
  };

  const canSend = !!value.trim() && !isSending;

  if (!isAuthenticated) {
    return (
      <div className="shrink-0 px-4 pb-4 pt-3 bg-white border-t border-gray-100">
        <div className="flex flex-col items-center gap-3 py-2">
          <p className="text-sm text-gray-500 text-center">
            Tozzy ile sohbet etmek için giriş yapman gerekiyor.
          </p>
          <Link
            href="/auth/login"
            className="w-full text-center bg-brand hover:bg-brand-dark text-white text-sm font-medium rounded-xl py-2.5 transition-colors"
          >
            Giriş Yap
          </Link>
        </div>
        <p className="text-center text-[10px] text-gray-500 mt-2">
          Tozzy yapay zeka ile çalışmaktadır, hatalar yapabilir.
        </p>
      </div>
    );
  }

  return (
    <div className="shrink-0 px-4 pb-4 pt-3 bg-white border-t border-gray-100">
      <div className={`flex items-end gap-2 bg-gray-100 rounded-xl px-4 py-2.5 transition-opacity duration-150 ${isSending ? "opacity-60" : ""}`}>
        <textarea
          ref={ref}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={handleKeyDown}
          onInput={(e) => {
            const el = e.currentTarget;
            el.style.height = "auto";
            el.style.height = `${el.scrollHeight}px`;
          }}
          placeholder="Bir şeyler sor..."
          rows={1}
          disabled={isSending}
          className="flex-1 bg-transparent resize-none text-sm text-gray-900 placeholder-gray-400 outline-none max-h-28 py-1 leading-relaxed"
        />
        <button
          onClick={onSend}
          disabled={!canSend}
          className={`w-8 h-8 rounded-lg flex items-center justify-center shrink-0 mb-0.5 transition-all duration-150 ${
            canSend ? "bg-brand hover:bg-brand-dark" : "bg-gray-300"
          }`}
        >
          {isSending ? (
            <Loader2 className="w-4 h-4 text-white animate-spin" />
          ) : (
            <ArrowUp className="w-4 h-4 text-white" />
          )}
        </button>
      </div>
      <p className="text-center text-[10px] text-gray-500 mt-2">
        Tozzy yapay zeka ile çalışmaktadır, hatalar yapabilir.
      </p>
    </div>
  );
};

export default TozyInput;